module.exports = __webpack_public_path__ + "static/media/mistenksam.130c7d89.m4a";